import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { tokenNotExpired } from 'angular2-jwt';

import { UserService } from './services/user.service';
import { SubscriptionOfferService } from './services/subscription-offer.service';
import { TrackerStatusService } from './services/trackerstatus.service';
import { environment } from '../environments/environment';
import { Log } from './utils/index';

declare var jQuery: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
  currentYear = (new Date()).getFullYear();
  appVersion = environment.version;

  notificationOptions = {
    timeOut: 3000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 2,
    showProgressBar: true,
    pauseOnHover: true
  };

  constructor(
    public location: Location,
    protected trackerStatusService: TrackerStatusService,
    protected subscriptionOfferService: SubscriptionOfferService,
    protected userService: UserService,
  ) {}

  @Log()
  ngOnInit(): void {
    this.clearSessionStorage();
    if (tokenNotExpired()) {
      this.trackerStatusService.getAll();
      this.subscriptionOfferService.getAll();
      this.userService.reloadUser();
    }
  }

  @Log()
  ngAfterViewInit(): void {
    jQuery('body').addClass(environment.bodyClass);
  }

  clearSessionStorage(): void {
    // Remove all saved search term
    Object.keys(sessionStorage).forEach(function(key) {
      if (key.startsWith('term')) {
        sessionStorage.removeItem(key);
      }
    });
  }

  getStyleLink(link: string): boolean {
    return true;
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/app.component.ts